export default [{
        "AppId": 180302,
        "Title": "登陆",
        "NavigationId": 10000,
        "ParentID": 0,
        "Url": "/login",
        "Path": "containers/Login",
        "Iconurl": "",
        "CreateTime": "2017-07-14 10:05:05",
        "ChildNavigations": null,
        "Level": 1
    },
    {
        "AppId": 180302,
        "Title": "404",
        "NavigationId": 10001,
        "ParentID": 0,
        "Url": "*",
        "Path": "components/Page404",
        "Iconurl": "",
        "CreateTime": "2017-07-14 10:05:05",
        "ChildNavigations": null,
        "Level": 1
    },
    {
        "AppId": 180302,
        "Title": "修改密码",
        "NavigationId": 10002,
        "ParentID": 0,
        "Url": "/updatePwd",
        "Path": "containers/UpdatePwd",
        "Iconurl": "",
        "CreateTime": "2017-10-31 10:05:05",
        "ChildNavigations": null,
        "Level": 1
    },
    {
        "AppId": 180302,
        "Title": "财经云",
        "NavigationId": 10003,
        "ParentID": 0,
        "Url": "/home",
        "Path": "containers/Home",
        "Iconurl": "",
        "CreateTime": "2017-12-18 10:46:43",
        "ChildNavigations": null,
        "Level": 1
    }
]


// WEBPACK FOOTER //
// ./src/js/routes/routes.js